unit GiftAidValidationErrorMessages;

interface

uses
  System.SysUtils, System.Classes;

type
  TGiftAidValidationErrorMessages = class
  public
    /// <summary>
    /// Converts a single CSV error row (FieldName,ErrorCode,Value,AutoFixed) into a short human-readable message.
    /// Returns empty string if the row is invalid or error code is Valid.
    /// </summary>
    class function CsvRowToShortMessage(const ACsvRow: string): string;
    /// <summary>
    /// Converts the CSV error string from TFullDonationRec.Error (semicolon-separated rows:
    /// FieldName,ErrorCode,Value,AutoFixed) into a short human-readable message for the user (bullet-separated).
    /// </summary>
    class function CsvToShortMessage(const ACsvError: string): string;
  end;

implementation

{ TGiftAidValidationErrorMessages }

const
  // Map error codes (from GiftAid.Interfaces Validation_Errors) to short user-facing text
  // 9 items: index 0..8
  ErrorCodeToText: array[0..8] of string = (
    'Valid',           // skip
    'is missing',
    'should be blank',
    'is too short',
    'is too long',
    'has invalid format',
    'is out of range',
    'cannot be zero',
    'possible duplicate'
  );
  // 9 items: index 0..8
  ErrorCodes: array[0..8] of string = (
    'Valid', 'Blank', 'NotBlank', 'TooShort', 'TooLong',
    'Format', 'OutOfRange', 'AmountZero', 'Duplicate'
  );
  // Friendly field names for display (same index as FieldKeys)
  // 11 items: index 0..10
  FieldToLabel: array[0..10] of string = (
    'Title', 'First name', 'Last name', 'Address', 'Post code',
    'Donation date', 'Donation date', 'Amount', 'Donation ID', 'Donor ID', 'Sponsored'
  );
  // Field names as emitted by TGiftAidValidation (GiftAid.Utils)
  // 11 items: index 0..10
  FieldKeys: array[0..10] of string = (
    'Title', 'Firstname', 'Lastname', 'Address', 'Postcode',
    'Donation', 'Future', 'Amount', 'DonationId', 'DonorId', 'Sponsored'
  );

class function TGiftAidValidationErrorMessages.CsvRowToShortMessage(const ACsvRow: string): string;
var
  lParts: TArray<string>;
  lFieldName, lErrorCode, lPhrase, lLabel: string;
  j, k: Integer;
begin
  Result := '';
  if ACsvRow.Trim = '' then
    Exit;
  lParts := ACsvRow.Trim.Split([',']);
  if Length(lParts) < 2 then
    Exit;
  lFieldName := lParts[0].Trim;
  lErrorCode := lParts[1].Trim;
  if SameText(lErrorCode, 'Valid') then
    Exit;

  lPhrase := '';
  for k := 0 to High(ErrorCodes) do
    if SameText(ErrorCodes[k], lErrorCode) then
    begin
      if k < Length(ErrorCodeToText) then
        lPhrase := ErrorCodeToText[k]
      else
        lPhrase := lErrorCode;
      Break;
    end;
  if lPhrase = '' then
    lPhrase := lErrorCode;

  lLabel := lFieldName;
  for j := 0 to High(FieldKeys) do
    if SameText(FieldKeys[j], lFieldName) and (j < Length(FieldToLabel)) then
    begin
      lLabel := FieldToLabel[j];
      Break;
    end;
  Result := lLabel + ' ' + lPhrase;
end;

class function TGiftAidValidationErrorMessages.CsvToShortMessage(const ACsvError: string): string;
var
  lRows: TArray<string>;
  lRow, lOne: string;
  lMsg: TStringList;
  j: Integer;
begin
  Result := '';
  if ACsvError.Trim = '' then
    Exit;
  lMsg := TStringList.Create;
  try
    lRows := ACsvError.Split([';']);
    for lRow in lRows do
    begin
      lOne := CsvRowToShortMessage(lRow);
      if lOne <> '' then
        lMsg.Add(lOne);
    end;
    if lMsg.Count > 0 then
    begin
      Result := lMsg[0];
      for j := 1 to lMsg.Count - 1 do
        Result := Result + ' • ' + lMsg[j];
    end;
  finally
    lMsg.Free;
  end;
end;

end.
